import {
  readPerUserFlag,
  setPerUserFlag,
} from 'components/shared/side-menu/helpers/per-user-local-storage';

const MONITORING_TOUR_SEEN_KEY_PREFIX = 'mv-monitoring-tour-seen';

export const hasSeenMonitoringTour = (
  oktaUserId: string | undefined
): boolean => {
  if (!oktaUserId) return false;

  return readPerUserFlag(MONITORING_TOUR_SEEN_KEY_PREFIX, oktaUserId);
};

export const recordMonitoringTourSeen = (
  oktaUserId: string | undefined
): void => {
  if (!oktaUserId) return;

  setPerUserFlag(MONITORING_TOUR_SEEN_KEY_PREFIX, oktaUserId);
};
